export enum VisualizationType {
  APPLICATION = 'APPLICATION',
  UPO = 'UPO',
  SIGNATURE = 'SIGNATURE',
  PO = 'PO',
}
